// Provincias y ciudades principales de Argentina
export const provinciasArgentinas = [
  {
    id: 1,
    nombre: "Buenos Aires",
    ciudades: [
      "La Plata", "Mar del Plata", "Bahía Blanca", "Tandil", "Olavarría",
      "Pergamino", "Junín", "Necochea", "Pilar", "San Nicolás", "Zárate",
      "Tigre", "San Isidro", "Vicente López", "San Martín", "Morón",
      "Quilmes", "Avellaneda", "Lanús", "Lomas de Zamora", "Tres de Febrero"
    ]
  },
  {
    id: 2,
    nombre: "Ciudad Autónoma de Buenos Aires",
    ciudades: ["CABA"]
  },
  {
    id: 3,
    nombre: "Catamarca",
    ciudades: [
      "San Fernando del Valle de Catamarca", "Andalgalá", "Belén",
      "Santa María", "Tinogasta", "Recreo"
    ]
  },
  {
    id: 4,
    nombre: "Chaco",
    ciudades: [
      "Resistencia", "Presidencia Roque Sáenz Peña", "Villa Ángela",
      "Barranqueras", "Charata", "General San Martín", "Quitilipi"
    ]
  },
  {
    id: 5,
    nombre: "Chubut",
    ciudades: [
      "Rawson", "Comodoro Rivadavia", "Puerto Madryn", "Trelew",
      "Esquel", "Sarmiento", "Puerto Deseado"
    ]
  },
  {
    id: 6,
    nombre: "Córdoba",
    ciudades: [
      "Córdoba", "Villa María", "Río Cuarto", "San Francisco",
      "Villa Carlos Paz", "Alta Gracia", "Bell Ville", "Jesús María",
      "Marcos Juárez", "La Falda", "Cruz del Eje", "Dean Funes"
    ]
  },
  {
    id: 7,
    nombre: "Corrientes",
    ciudades: [
      "Corrientes", "Goya", "Paso de los Libres", "Mercedes",
      "Curuzú Cuatiá", "Esquina", "Santo Tomé", "Bella Vista"
    ]
  },
  {
    id: 8,
    nombre: "Entre Ríos",
    ciudades: [
      "Paraná", "Concordia", "Gualeguaychú", "Concepción del Uruguay",
      "Victoria", "Gualeguay", "Villaguay", "Chajarí", "Colón"
    ]
  },
  {
    id: 9,
    nombre: "Formosa",
    ciudades: [
      "Formosa", "Clorinda", "Pirané", "El Colorado",
      "Laguna Blanca", "Las Lomitas"
    ]
  },
  {
    id: 10,
    nombre: "Jujuy",
    ciudades: [
      "San Salvador de Jujuy", "San Pedro", "Libertador General San Martín",
      "Palpalá", "La Quiaca", "Humahuaca", "Tilcara"
    ]
  },
  {
    id: 11,
    nombre: "La Pampa",
    ciudades: [
      "Santa Rosa", "General Pico", "Toay", "General Acha",
      "Macachín", "Realicó", "Eduardo Castex"
    ]
  },
  {
    id: 12,
    nombre: "La Rioja",
    ciudades: [
      "La Rioja", "Chilecito", "Aimogasta", "Chepes",
      "Chamical", "Villa Unión"
    ]
  },
  {
    id: 13,
    nombre: "Mendoza",
    ciudades: [
      "Mendoza", "San Rafael", "Godoy Cruz", "Guaymallén", "Las Heras",
      "Maipú", "Luján de Cuyo", "San Martín", "Tunuyán", "Malargüe"
    ]
  },
  {
    id: 14,
    nombre: "Misiones",
    ciudades: [
      "Posadas", "Oberá", "Eldorado", "Puerto Iguazú",
      "Apóstoles", "Leandro N. Alem", "Jardín América", "Montecarlo"
    ]
  },
  {
    id: 15,
    nombre: "Neuquén",
    ciudades: [
      "Neuquén", "San Martín de los Andes", "Villa La Angostura",
      "Zapala", "Cutral Có", "Centenario", "Plottier", "Junín de los Andes"
    ]
  },
  {
    id: 16,
    nombre: "Río Negro",
    ciudades: [
      "Viedma", "San Carlos de Bariloche", "General Roca", "Cipolletti",
      "Villa Regina", "Cinco Saltos", "El Bolsón", "Catriel"
    ]
  },
  {
    id: 17,
    nombre: "Salta",
    ciudades: [
      "Salta", "San Ramón de la Nueva Orán", "Tartagal", "Metán",
      "Cafayate", "General Güemes", "Rosario de la Frontera", "Joaquín V. González"
    ]
  },
  {
    id: 18,
    nombre: "San Juan",
    ciudades: [
      "San Juan", "Rawson", "Chimbas", "Rivadavia", "Santa Lucía",
      "Pocito", "Caucete", "9 de Julio", "Albardón"
    ]
  },
  {
    id: 19,
    nombre: "San Luis",
    ciudades: [
      "San Luis", "Villa Mercedes", "La Punta", "Merlo",
      "Justo Daract", "Tilisarao", "Concarán"
    ]
  },
  {
    id: 20,
    nombre: "Santa Cruz",
    ciudades: [
      "Río Gallegos", "Caleta Olivia", "Pico Truncado", "Puerto Deseado",
      "Puerto San Julián", "El Calafate", "Las Heras", "Perito Moreno"
    ]
  },
  {
    id: 21,
    nombre: "Santa Fe",
    ciudades: [
      "Santa Fe", "Rosario", "Rafaela", "Reconquista", "Venado Tuerto",
      "Villa Gobernador Gálvez", "Esperanza", "Santo Tomé", "San Lorenzo",
      "Casilda", "Cañada de Gómez", "Firmat"
    ]
  },
  {
    id: 22,
    nombre: "Santiago del Estero",
    ciudades: [
      "Santiago del Estero", "La Banda", "Termas de Río Hondo",
      "Frías", "Añatuya", "Fernández", "Quimilí"
    ]
  },
  {
    id: 23,
    nombre: "Tierra del Fuego",
    ciudades: [
      "Ushuaia", "Río Grande", "Tolhuin"
    ]
  },
  {
    id: 24,
    nombre: "Tucumán",
    ciudades: [
      "San Miguel de Tucumán", "Yerba Buena", "Tafí Viejo", "Concepción",
      "Aguilares", "Monteros", "Famaillá", "Banda del Río Salí"
    ]
  }
];

// Función helper para obtener ciudades de una provincia
export const getCiudadesByProvincia = (provinciaNombre) => {
  const provincia = provinciasArgentinas.find(p => p.nombre === provinciaNombre);
  return provincia ? provincia.ciudades : [];
};

// Función helper para obtener solo los nombres de provincias
export const getProvinciasNames = () => {
  return provinciasArgentinas.map(p => p.nombre);
};
